<template>
<div class="l-fu-introduction">
    <div class="img">
        <l-img :src='src'></l-img>
    </div>

    <div class="info">
        <l-info-title type='center'>
            {{title}}
        </l-info-title>
        <p class="content">
            {{ content }}
        </p>
    </div>
    
</div>   
</template>

<script>
export default {
    name: 'l-fu-introduction',
    props: {
        src:{
            default: ''
        },
        title: {
            default:''
        },
        content: {
            default:''
        }
    },

}
</script>
<style lang="scss" scoped>

.l-fu-introduction{
    box-sizing: border-box;
    height: 400px;
    border: 1px solid $color_border;
    text-align: center;
    
    .img{
        padding-bottom: 26px;
        height: 200px;
    }
    
    .info{
        margin: auto;
        width: 240px;
    }
    .content{
        @include font_content;
        margin-top: 20px; 
    }
    
}

</style>